module.exports = __webpack_public_path__ + "img/aeroland-pricing-image-05.3f55e09a.png";